import { render } from "./ColorwayEditor.vue?vue&type=template&id=28e2ba67&scoped=true"
import script from "./ColorwayEditor.vue?vue&type=script&lang=js"
export * from "./ColorwayEditor.vue?vue&type=script&lang=js"

import "./ColorwayEditor.vue?vue&type=style&index=0&id=28e2ba67&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28e2ba67"]])

export default __exports__